import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { NextArrowIcon } from './icons/NextArrowIcon';
import { useRenderContext } from './RenderContext';

/** Figma Next control — label plus Atlas outlined right arrow (not a text chevron). */
export const NextButton = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  function NextButton({ className, disabled, onClick, ...props }, ref) {
    // Read here rather than passed by each layout: every in-slide Next in the deck is this
    // component, so one lookup keeps them all saying the same thing as the deck nav (CEE-734).
    //
    // `onNext` is the DEFAULT action, not an opt-in a layout has to remember. The deck carries no
    // navigation bar, so this button is the only way off the slide — and three families shipped one
    // that was wired to nothing at all, which is the failure this default makes unrepresentable.
    const { nextLabel, strings, onNext } = useRenderContext();
    return (
      <button
        ref={ref}
        type="button"
        className={['cs-next', className].filter(Boolean).join(' ') || undefined}
        disabled={disabled}
        onClick={onClick ?? onNext}
        {...props}
      >
        {nextLabel ?? strings.next}
        <NextArrowIcon />
      </button>
    );
  },
);
